import axios from "axios";

export interface User {
  email: string | null;
  isEmailConfirmed: boolean;
  phone: string | null;
  isPhoneConfirmed: boolean;
  codePostal: string | null;
  isEmailArrivageCoupDeCoeur: boolean;
  isEmailEvents: boolean;
  isEmailWhatIsNewExclusif: boolean;
  magasinId: string | null;
  nom: string | null;
  prenom: string | null;
}

export interface ManageInfoUpdateRequest {
  newEmail?: string;
  newPassword?: string;
  oldPassword: string;
  nom: string;
  prenom: string;
  codePostal?: string;
  magasinId?: number;
  isEmailArrivageCoupDeCoeur: boolean;
  isEmailEvents: boolean;
  isEmailWhatIsNewExclusif: boolean;
}

export const fetchManageInfo = async (): Promise<User | null> => {
  try {
    const apiUrl = import.meta.env.VITE_API_URL;
    const response = await axios.get<User>(
      `${apiUrl}/manage/info`,
      { withCredentials: true }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      // console.error("Failed to fetch manage info", response.status);
      return null;
    }
  } catch (error) {
    // console.error("Error fetching manage info", error);
    return null;
  }
};

export const updateManageInfo = async (
  data: ManageInfoUpdateRequest
): Promise<User | null> => {
  try {
    const apiUrl = import.meta.env.VITE_API_URL;
    const response = await axios.post<User>(
      `${apiUrl}/manage/info`,
      data,
      { withCredentials: true }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      // console.error("Failed to update manage info", response.status);
      return null;
    }
  } catch (error) {
    // console.error("Error updating manage info", error);
    return null;
  }
};